import { state, setActiveTeamId } from './globals.js';
import { openConfirmModal } from './ui.js';

function escapeHtml(value) {
  return String(value || '').replace(/[&<>"']/g, (ch) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  }[ch]));
}

function scopeName(teamID) {
  const id = Number(teamID || 0);
  if (!id) return 'your personal account';
  const team = (state.teams || []).find((t) => Number(t.team_id || 0) === id);
  return team?.name ? `team "${team.name}"` : `team ${id}`;
}

export function teamByID(teamID) {
  const id = Number(teamID || 0);
  return (state.teams || []).find((t) => Number(t.team_id || 0) === id) || null;
}

export async function confirmAndSetActiveTeamId(teamID) {
  const nextID = Number(teamID || 0);
  const next = Number.isFinite(nextID) && nextID > 0 ? nextID : 0;
  const current = Number(state.activeTeamId || 0);
  if (next === current) return true;

  let title = '⚠️ Change Scope';
  let confirmText = 'Change';
  if (!current && next) {
    title = '⚠️ Enter Team';
    confirmText = 'Enter Team';
  } else if (current && !next) {
    title = '⚠️ Exit Team';
    confirmText = 'Exit Team';
  } else if (current && next) {
    title = '⚠️ Switch Team';
    confirmText = 'Switch Team';
  }

  const nextName = escapeHtml(scopeName(next));
  const currentName = escapeHtml(scopeName(current));
  const message = `Switch from ${currentName} to ${nextName}?`;
  const ok = await openConfirmModal({
    title,
    message,
    confirmText,
    cancelText: 'Cancel',
    confirmClass: 'danger-emoji-btn',
  });
  if (!ok) return false;

  setActiveTeamId(next);
  return true;
}
